import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["breakdownToday", "breakdownScheduled", "submit"]
  static values = {
    currency: String,
    totalAmountCents: Number,
    breakdownTodayTemplate: String,
    breakdownScheduledTemplate: String,
    submitTemplate: String,
    locale: String,
    dateAmounts: { type: Object, default: {} },
  }

  connect() {
    this.setupDatePickerListener()
  }

  setupDatePickerListener() {
    const datePickerElement = this.element.querySelector('[data-controller*="date-picker"]')
    if (!datePickerElement) return

    const hiddenField = datePickerElement.querySelector('[data-date-picker-target="hidden"]')
    if (!hiddenField) return

    let previousValue = hiddenField.value
    setInterval(() => {
      if (hiddenField.value !== previousValue && hiddenField.value) {
        previousValue = hiddenField.value
        this.dateChanged(hiddenField.value)
      }
    }, 500)

    hiddenField.addEventListener("input", (event) => this.dateChanged(event.target.value))
    hiddenField.addEventListener("change", (event) => this.dateChanged(event.target.value))

    const displayedField = datePickerElement.querySelector('[data-date-picker-target="displayed"]')
    if (displayedField) {
      displayedField.addEventListener("click", () => {
        setTimeout(() => {
          if (hiddenField.value) this.dateChanged(hiddenField.value)
        }, 100)
      })
    }
  }

  dateChanged(dateString) {
    const totalCents = this.totalCentsForDate(dateString)
    const tokenCents = this.tokenCentsFor(totalCents)
    const remainingCents = totalCents - tokenCents

    const locale = this.localeValue || "en"
    const currency = this.currencyValue

    const tokenFormatted = this.formatMoney(tokenCents, currency, locale)
    const remainingFormatted = this.formatMoney(remainingCents, currency, locale)
    const dateFormatted = this.formatDate(dateString, locale)

    if (this.hasBreakdownTodayTarget) {
      this.breakdownTodayTarget.textContent = this.breakdownTodayTemplateValue.replace(
        "%{token_amount}",
        tokenFormatted,
      )
    }

    if (this.hasBreakdownScheduledTarget) {
      this.breakdownScheduledTarget.textContent = this.breakdownScheduledTemplateValue
        .replace("%{remaining_amount}", remainingFormatted)
        .replace("%{scheduled_date}", dateFormatted)
    }

    if (this.hasSubmitTarget) {
      this.submitTarget.textContent = this.submitTemplateValue
        .replace("%{token_amount}", tokenFormatted)
        .replace("%{remaining_amount}", remainingFormatted)
        .replace("%{scheduled_date}", dateFormatted)
    }
  }

  totalCentsForDate(dateString) {
    const dateAmounts = this.dateAmountsValue
    if (dateAmounts[dateString] && dateAmounts[dateString].total_amount_cents != null) {
      return dateAmounts[dateString].total_amount_cents
    }
    return this.totalAmountCentsValue
  }

  tokenCentsFor(totalCents) {
    if (totalCents < 3000) return 0
    if (totalCents < 10000) return 500
    return 1000
  }

  formatMoney(cents, currency, locale) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
    }).format(cents / 100)
  }

  formatDate(dateString, locale) {
    const date = new Date(dateString + "T00:00:00")
    return date.toLocaleDateString(locale, { day: "numeric", month: "short", year: "numeric" })
  }
}
